<template>
  <BaseShipmentTimelineItem
    :id="uid"
    class="tender-request"
    :event-type="t('tenderInfo.requestSent')"
    :subheader="
      t('tenderInfo.requestedViaParam', {
        param: translateEnum(tenderRequest.tenderMethod, 'TenderMethod'),
      })
    "
    :date-label="t('tenderInfo.requestDate')"
    :formatted-date="renderDateTime(tenderRequest.createdDate)"
  />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useUid } from '@rygen/rygen-ui/composables';
import { renderDateTime, translateEnum } from '@rygen/rygen-ui/i18n';

import { TenderRequest } from '@/model';

import BaseShipmentTimelineItem from '@/components/shipment/BaseShipmentTimelineItem.vue';

const props = defineProps({
  tenderRequest: {
    type: Object as PropType<TenderRequest>,
    required: true,
  },
});
const { tenderRequest } = toRefs(props);

const { t } = useI18n();
const { uid } = useUid('tender-request');
</script>
